export enum QueryKey {
	Labels = 'labels',
	Bookmarks = 'bookmarks',
	SuggestedLabels = 'suggested-labels',
}
